/* DRENCH theme JS — cart drawer (Shopify AJAX Cart API), gallery, slideshow,
   mobile menu, variant picker, coverage calculator, toast. No dependencies. */
(function () {
  "use strict";

  var moneyFormat = (window.DrenchTheme && window.DrenchTheme.moneyFormat) || "€{{amount}}";

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace(".", ","));
  }

  /* ---------- Toast (replaces sonner) ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("show"); }, 3000);
  }

  /* ---------- Colour helpers (ported from src/lib/shopify.ts) ---------- */
  var COLOR_SWATCHES = {
    "Old School White": "#F5F2EC", "Sahara Stone": "#EFE4CC", "Sand Dune": "#D9C7A7",
    "Soft Greige": "#CFC6B8", "Natural Greige": "#B0A695", "Urban Cocoa": "#705536",
    "Mystic": "#909090", "Deep Slate": "#444444", "Midnight Eclipse": "#1A1C1F",
    "Willow Green": "#6A7755", "Vintage Mauve": "#8A6069", "Canyon Sun": "#A16126",
    "Dandelion Yellow": "#E7D038", "Ocean Blue": "#4E7F9E", "Soft White": "#F5F2EC",
    "Magic Coat": "#000000"
  };
  var COLOR_NAME_ALIASES = {
    "Warm Cream": "Sahara Stone", "Natural Beige": "Sand Dune", "Misty Grey": "Mystic",
    "Slate Grey": "Deep Slate", "Vintage Pink": "Vintage Mauve", "Black": "Urban Cocoa"
  };
  function getColorName(title) {
    if (/driveway\s*nano/i.test(title)) return "Magic Coat";
    var parts = title.split("—");
    var raw = (parts[1] || title).trim();
    return COLOR_NAME_ALIASES[raw] || raw;
  }
  function getSwatchHex(title) {
    return COLOR_SWATCHES[getColorName(title)] || "#cccccc";
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    state: null,

    open: function () {
      /* Cart drawer removed — keep cart in sync; no drawer to open. */
      this.sync();
    },
    close: function () {},
    sync: function () {
      var self = this;
      return fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.state = cart; self.render(); return cart; })
        .catch(function () {});
    },
    add: function (variantId, quantity) {
      var self = this;
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "Could not add to basket"); });
        return r.json();
      }).then(function () { return self.sync(); });
    },
    changeLine: function (lineKey, quantity) {
      var self = this;
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { self.state = cart; self.render(); });
    },
    discountCode: function () {
      try { return window.localStorage.getItem("drench-discount-code") || ""; } catch (e) { return ""; }
    },
    setDiscountCode: function (code) {
      try {
        if (code) window.localStorage.setItem("drench-discount-code", code);
        else window.localStorage.removeItem("drench-discount-code");
      } catch (e) { /* ignore */ }
    },
    checkout: function () {
      var code = this.discountCode();
      if (code) {
        window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/checkout";
      } else {
        window.location.href = "/checkout";
      }
    },

    render: function () {
      var cart = this.state;
      if (!cart) return;

      var count = cart.item_count;
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        var prev = el.textContent;
        el.textContent = count;
        el.hidden = count === 0;
        // Briefly animate the badge when the count changes
        if (String(prev) !== String(count) && count > 0) {
          el.classList.remove("cart-count--bump");
          void el.offsetWidth; /* restart animation */
          el.classList.add("cart-count--bump");
        }
      });

      var drawer = document.getElementById("CartDrawer");
      if (!drawer) return;

      var sub = drawer.querySelector("[data-cart-subtitle]");
      if (sub) sub.textContent = count === 0 ? "Your cart is empty" : count + " can" + (count !== 1 ? "s" : "") + " of paint";

      var empty = drawer.querySelector("[data-cart-empty]");
      var full = drawer.querySelector("[data-cart-full]");
      if (empty) empty.hidden = count !== 0;
      if (full) full.hidden = count === 0;
      if (count === 0) return;

      var list = drawer.querySelector("[data-cart-items]");
      if (list) {
        list.innerHTML = cart.items.map(function (item) {
          var colorName = getColorName(item.product_title);
          var isMagicCoat = /driveway\s*nano|magic\s*coat/i.test(item.product_title);
          var sizeLabel = item.variant_title || "";
          var descriptor = isMagicCoat
            ? (sizeLabel ? sizeLabel + " · 15 Litres" : "15 Litres")
            : (sizeLabel ? sizeLabel + " · All In One Paint" : "All In One Paint");
          var media;
          if (item.image) {
            media = '<img src="' + item.image + '&width=128" alt="" loading="lazy">';
          } else if (isMagicCoat) {
            media = "";
          } else {
            media = '<div style="width:100%;height:100%;background:' + getSwatchHex(item.product_title) + '"></div>';
          }
          return (
            '<div class="cart-item" data-line-key="' + item.key + '">' +
              '<div class="cart-item__media">' + media + "</div>" +
              '<div class="cart-item__body">' +
                '<h4 class="cart-item__title">' + colorName + "</h4>" +
                '<p class="cart-item__desc">' + descriptor + "</p>" +
                '<p class="cart-item__price">' + formatMoney(item.final_price) + "</p>" +
                '<div class="cart-item__controls">' +
                  '<button type="button" class="cart-item__qty-btn" data-cart-qty="-1" aria-label="Decrease quantity of ' + colorName + '">' + iconSvg("minus") + "</button>" +
                  '<span class="cart-item__qty">' + item.quantity + "</span>" +
                  '<button type="button" class="cart-item__qty-btn" data-cart-qty="1" aria-label="Increase quantity of ' + colorName + '">' + iconSvg("plus") + "</button>" +
                  '<button type="button" class="cart-item__remove" data-cart-remove aria-label="Remove ' + colorName + ' from cart">' + iconSvg("trash") + "</button>" +
                "</div>" +
              "</div>" +
            "</div>"
          );
        }).join("");
      }

      var subtotal = drawer.querySelector("[data-cart-subtotal]");
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
      var total = drawer.querySelector("[data-cart-total]");
      if (total) total.textContent = formatMoney(cart.total_price);

      this.renderDiscount();
    },

    renderDiscount: function () {
      var drawer = document.getElementById("CartDrawer");
      if (!drawer) return;
      var code = this.discountCode();
      var inputWrap = drawer.querySelector("[data-discount-input-wrap]");
      var appliedWrap = drawer.querySelector("[data-discount-applied-wrap]");
      if (!inputWrap || !appliedWrap) return;
      if (code) {
        inputWrap.hidden = true;
        appliedWrap.hidden = false;
        var label = appliedWrap.querySelector("[data-discount-code-label]");
        if (label) label.textContent = code;
      } else {
        inputWrap.hidden = false;
        appliedWrap.hidden = true;
      }
    }
  };
  window.DrenchCart = Cart;

  function iconSvg(name) {
    var tpl = document.getElementById("icon-" + name);
    return tpl ? tpl.innerHTML : "";
  }

  /* ---------- Global click handling ---------- */
  document.addEventListener("click", function (e) {
    var t;

    if ((t = e.target.closest("[data-cart-open]"))) { e.preventDefault(); Cart.open(); return; }
    if ((t = e.target.closest("[data-cart-close]"))) { e.preventDefault(); Cart.close(); return; }
    if ((t = e.target.closest("[data-cart-checkout]"))) { e.preventDefault(); Cart.checkout(); return; }

    /* Basket page: "Update discount code" — reveal the input, hide the applied chip */
    if ((t = e.target.closest("[data-discount-update-toggle]"))) {
      e.preventDefault();
      var wrap0 = t.closest("[data-discount-wrap]");
      if (!wrap0) return;
      var applied0 = wrap0.querySelector("[data-discount-applied]");
      var form0 = wrap0.querySelector("[data-discount-form]");
      if (applied0) applied0.hidden = true;
      if (form0) { form0.hidden = false; var inp0 = form0.querySelector("[data-discount-input]"); if (inp0) inp0.focus(); }
      return;
    }

    /* Basket page: apply a discount code, validate it applied, revert on failure */
    if ((t = e.target.closest("[data-discount-apply]"))) {
      e.preventDefault();
      var wrap = t.closest("[data-discount-wrap]");
      var input = wrap ? wrap.querySelector("[data-discount-input]") : null;
      var errEl = wrap ? wrap.querySelector("[data-discount-error]") : null;
      var currentCode = wrap ? (wrap.getAttribute("data-current-code") || "") : "";
      var code = input ? input.value.trim() : "";
      if (errEl) errEl.hidden = true;
      if (!code) { if (input) input.focus(); return; }
      t.disabled = true;
      var originalLabel = t.textContent;
      t.textContent = "Checking…";

      /* Apply the code in the background via the /discount route, then read the cart
         to see whether it actually landed. If yes -> reload. If no -> invalid:
         show error, and re-apply the previous working code (revert). */
      function activate(c) {
        return fetch("/discount/" + encodeURIComponent(c), { redirect: "follow" }).catch(function () {});
      }
      function cartDiscounts() {
        return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
          return (cart.cart_level_discount_applications || []).map(function (d) {
            return (d.title || "").toUpperCase();
          });
        });
      }
      activate(code).then(function () {
        return cartDiscounts();
      }).then(function (codes) {
        var applied = codes.indexOf(code.toUpperCase()) !== -1;
        if (applied) {
          window.location.href = "/cart";
          return;
        }
        /* Invalid: show error and revert to previous working code if there was one */
        if (errEl) errEl.hidden = false;
        t.disabled = false;
        t.textContent = originalLabel;
        if (input) { input.value = ""; input.focus(); }
        if (currentCode) {
          activate(currentCode).then(function () { /* previous code restored silently */ });
        }
      }).catch(function () {
        if (errEl) errEl.hidden = false;
        t.disabled = false;
        t.textContent = originalLabel;
      });
      return;
    }

    /* Basket page: remove an applied discount (best-effort via RESET override) */
    if ((t = e.target.closest("[data-discount-remove]"))) {
      e.preventDefault();
      t.disabled = true;
      t.textContent = "Removing…";
      window.location.href = "/discount/RESET?redirect=/cart";
      return;
    }

    /* Basket page quantity change / remove (line-based, AJAX, then refresh page) */
    if ((t = e.target.closest("[data-cart-change]"))) {
      e.preventDefault();
      var line = t.getAttribute("data-line");
      var newQty = t.getAttribute("data-qty");
      if (line == null || newQty == null) return;
      t.disabled = true;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(newQty, 10) })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { t.disabled = false; toast("Could not update basket"); });
      return;
    }

    if ((t = e.target.closest("[data-cart-qty]"))) {
      var row = t.closest("[data-line-key]");
      if (!row) return;
      var qtyEl = row.querySelector(".cart-item__qty");
      var current = parseInt(qtyEl.textContent, 10) || 1;
      var next = current + parseInt(t.getAttribute("data-cart-qty"), 10);
      Cart.changeLine(row.getAttribute("data-line-key"), Math.max(0, next));
      return;
    }
    if ((t = e.target.closest("[data-cart-remove]"))) {
      var row2 = t.closest("[data-line-key]");
      if (row2) Cart.changeLine(row2.getAttribute("data-line-key"), 0);
      return;
    }

    /* Quick add from product cards */
    if ((t = e.target.closest("[data-quick-add]"))) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = t.getAttribute("data-quick-add");
      if (!variantId) return;
      t.disabled = true;
      var original = t.innerHTML;
      t.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
      Cart.add(variantId, 1).then(function () {
        t.disabled = false;
        t.innerHTML = original;
        Cart.sync();
        toast("Added to basket");
      }).catch(function (err) {
        t.disabled = false;
        t.innerHTML = original;
        toast(err.message || "Could not add to basket");
      });
      return;
    }

    /* Mobile menu */
    if ((t = e.target.closest("[data-menu-toggle]"))) {
      var nav = document.getElementById("MobileNav");
      var isOpen = !nav.hidden;
      nav.hidden = isOpen;
      t.setAttribute("aria-expanded", String(!isOpen));
      t.querySelector("[data-icon-menu]").hidden = !isOpen ? true : false;
      t.querySelector("[data-icon-close]").hidden = !isOpen ? false : true;
      var projects = document.getElementById("MobileProjects");
      var main = document.getElementById("MobileNavMain");
      if (projects && main) { projects.hidden = true; main.hidden = false; }
      return;
    }
    if ((t = e.target.closest("[data-mobile-projects-open]"))) {
      document.getElementById("MobileNavMain").hidden = true;
      document.getElementById("MobileProjects").hidden = false;
      return;
    }
    if ((t = e.target.closest("[data-mobile-projects-back]"))) {
      document.getElementById("MobileProjects").hidden = true;
      document.getElementById("MobileNavMain").hidden = false;
      return;
    }

    /* Desktop projects dropdown (click toggle; hover handled by CSS) */
    if ((t = e.target.closest("[data-dropdown-toggle]"))) {
      var dd = t.closest(".nav-dropdown");
      dd.classList.toggle("open");
      t.setAttribute("aria-expanded", dd.classList.contains("open") ? "true" : "false");
      return;
    }
    var openDd = document.querySelector(".nav-dropdown.open");
    if (openDd && !openDd.contains(e.target)) openDd.classList.remove("open");
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") Cart.close();
  });

  /* ---------- Product page: variant picker, qty, gallery ---------- */
  function initProductPage() {
    var root = document.querySelector("[data-product-page]");
    if (!root) return;

    var variantButtons = root.querySelectorAll("[data-variant-button]");
    var priceEl = root.querySelector("[data-product-price]");
    var priceVariantEl = root.querySelector("[data-price-variant]");
    var qtyEl = root.querySelector("[data-qty-value]");
    var addBtn = root.querySelector("[data-product-add]");
    var buyNowBtn = root.querySelector("[data-buy-now]");
    var qty = 1;

    if (buyNowBtn) {
      function resetBuyNow() {
        buyNowBtn.style.pointerEvents = "";
        buyNowBtn.style.opacity = "";
      }
      buyNowBtn.addEventListener("click", function (e) {
        e.preventDefault();
        var variantId = buyNowBtn.getAttribute("data-variant-id");
        if (!variantId) return;
        buyNowBtn.style.pointerEvents = "none";
        buyNowBtn.style.opacity = "0.7";
        Cart.add(variantId, qty).then(function () {
          window.location.href = "/checkout";
        }).catch(function (err) {
          resetBuyNow();
          toast(err.message || "Could not proceed to checkout");
        });
      });
      /* Reset if the page is restored from the back/forward cache (button was left faded) */
      window.addEventListener("pageshow", function (e) { if (e.persisted) resetBuyNow(); });
    }

    root.querySelectorAll("[data-qty-change]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        qty = Math.max(1, qty + parseInt(btn.getAttribute("data-qty-change"), 10));
        qtyEl.textContent = qty;
      });
    });

    function selectedVariant() {
      var active = root.querySelector("[data-variant-button].active");
      return active || variantButtons[0] || null;
    }

    variantButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        variantButtons.forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        if (priceEl) priceEl.textContent = btn.getAttribute("data-variant-price");
        if (priceVariantEl) priceVariantEl.textContent = "/ " + btn.getAttribute("data-variant-title");
        if (addBtn) addBtn.disabled = btn.getAttribute("data-variant-available") !== "true";
        /* Swap the product image(s) to this variant's image, if it has one.
           Updates BOTH the main gallery image and the small intro image (mobile). */
        var vImg = btn.getAttribute("data-variant-image");
        if (vImg) {
          var targets = root.querySelectorAll("[data-gallery-main], .pd__intro-img img");
          targets.forEach(function (imgEl) {
            imgEl.removeAttribute("srcset");
            imgEl.setAttribute("src", vImg);
            imgEl.src = vImg;
            imgEl.alt = btn.getAttribute("data-variant-title") || imgEl.alt;
          });
        }
      });
    });

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var v = selectedVariant();
        var variantId = v ? v.getAttribute("data-variant-id") : addBtn.getAttribute("data-variant-id");
        if (!variantId) return;
        addBtn.disabled = true;
        var original = addBtn.innerHTML;
        addBtn.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
        Cart.add(variantId, qty).then(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = original;
          Cart.sync();
          var colorName = root.getAttribute("data-colour-name") || "";
          var vt = v ? v.getAttribute("data-variant-title") : "";
          toast("Added " + qty + " × " + colorName + (vt ? " (" + vt + ")" : "") + " to basket");
        }).catch(function (err) {
          addBtn.disabled = false;
          addBtn.innerHTML = original;
          toast(err.message || "Could not add to basket");
        });
      });
    }

    /* Gallery */
    var mainImg = root.querySelector("[data-gallery-main]");
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-thumb]"));
    var index = 0;
    function show(i) {
      if (!thumbs.length || !mainImg) return;
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      mainImg.src = t.getAttribute("data-full-src");
      mainImg.alt = t.querySelector("img") ? t.querySelector("img").alt : "";
      thumbs.forEach(function (b, bi) { b.classList.toggle("active", bi === index); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () { show(i); });
    });
    root.querySelectorAll("[data-gallery-prev]").forEach(function (b) {
      b.addEventListener("click", function () { show(index - 1); });
    });
    root.querySelectorAll("[data-gallery-next]").forEach(function (b) {
      b.addEventListener("click", function () { show(index + 1); });
    });
    var thumbStrip = root.querySelector("[data-gallery-thumbs]");
    root.querySelectorAll("[data-thumbs-scroll]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!thumbStrip) return;
        var dir = parseInt(b.getAttribute("data-thumbs-scroll"), 10);
        thumbStrip.scrollBy({ left: dir * thumbStrip.clientWidth * 0.8, behavior: "smooth" });
      });
    });
  }

  /* ---------- Slideshow (Magic Coat promo) ---------- */
  function initSlideshows() {
    document.querySelectorAll("[data-slideshow]").forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll(".slideshow__slide"));
      var dots = Array.prototype.slice.call(root.querySelectorAll(".slideshow__dot"));
      if (slides.length < 2) return;
      var index = 0;
      var timer = null;
      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) { s.classList.toggle("active", si === index); });
        dots.forEach(function (d, di) { d.classList.toggle("active", di === index); });
      }
      function start() {
        stop();
        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          timer = setInterval(function () { show(index + 1); }, 4000);
        }
      }
      function stop() { if (timer) clearInterval(timer); }
      root.querySelectorAll("[data-slide-prev]").forEach(function (b) {
        b.addEventListener("click", function () { show(index - 1); start(); });
      });
      root.querySelectorAll("[data-slide-next]").forEach(function (b) {
        b.addEventListener("click", function () { show(index + 1); start(); });
      });
      dots.forEach(function (d, di) {
        d.addEventListener("click", function () { show(di); start(); });
      });
      show(0);
      start();
    });
  }

  /* ---------- Coverage calculator ---------- */
  function initCalculator() {
    var root = document.querySelector("[data-coverage-calculator]");
    if (!root) return;
    var PRODUCTS = {
      drench: { label: "Drench All In One Paint", coveragePerLitre: 11, tubSize: 2.5, tubLabel: "2.5L tin", coats: 2 },
      "magic-coat": { label: "Magic Coat (Driveway)", coveragePerLitre: 100 / 15, tubSize: 15, tubLabel: "15L tub", coats: 1 }
    };
    var state = { product: "drench", mode: "dimensions", area: "20", width: "4", height: "2.5", coats: "2" };

    function round1(n) { return Math.round(n * 10) / 10; }

    function compute() {
      var spec = PRODUCTS[state.product];
      var a = state.mode === "area" ? parseFloat(state.area) : parseFloat(state.width) * parseFloat(state.height);
      var c = Math.max(1, parseInt(state.coats || "1", 10) || 1);
      var out = root.querySelector("[data-calc-result]");
      var emptyMsg = root.querySelector("[data-calc-empty]");
      if (!isFinite(a) || a <= 0) {
        out.hidden = true; emptyMsg.hidden = false;
        return;
      }
      var litresExact = (a * c) / spec.coveragePerLitre;
      var litres = Math.ceil(litresExact * 10) / 10;
      var tubs = Math.ceil(litresExact / spec.tubSize);
      out.hidden = false; emptyMsg.hidden = true;
      root.querySelector("[data-calc-litres]").textContent = litres + "L";
      root.querySelector("[data-calc-tubs]").textContent = tubs + " × " + spec.tubLabel;
      root.querySelector("[data-calc-area]").textContent = round1(a) + " m²";
      root.querySelector("[data-calc-coats]").textContent = String(c);
      root.querySelector("[data-calc-coverage]").textContent = round1(spec.coveragePerLitre) + " m²/L";
    }

    root.querySelectorAll("[data-calc-product]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        state.product = radio.value;
        state.coats = String(PRODUCTS[state.product].coats);
        root.querySelector("[data-calc-input='coats']").value = state.coats;
        root.querySelectorAll(".calc__product-option").forEach(function (l) {
          l.classList.toggle("active", l.contains(radio));
        });
        compute();
      });
    });
    root.querySelectorAll("[data-calc-mode]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.mode = btn.getAttribute("data-calc-mode");
        root.querySelectorAll("[data-calc-mode]").forEach(function (b) {
          b.classList.toggle("active", b === btn);
        });
        root.querySelector("[data-calc-dims]").hidden = state.mode !== "dimensions";
        root.querySelector("[data-calc-area-field]").hidden = state.mode !== "area";
        compute();
      });
    });
    root.querySelectorAll("[data-calc-input]").forEach(function (input) {
      input.addEventListener("input", function () {
        state[input.getAttribute("data-calc-input")] = input.value;
        compute();
      });
    });
    compute();
  }


  /* ---------- Magic Coat landing page ---------- */
  function initMagicCoat() {
    var root = document.querySelector("[data-magic-coat]");
    if (!root) return;

    /* Region flag/label on the price card is rendered server-side from the
       active currency (see page-magic-coat.liquid). No JS region logic needed. */

    /* ----- Media gallery: images + optional video, autoplay 4s ----- */
    var mainWrap = root.querySelector("[data-mc-main]");
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-mc-thumb]"));
    var thumbStrip = root.querySelector("[data-mc-thumbs]");
    var index = 0;
    var autoplay = true;
    var autoplayTimer = null;
    var autoplayLockUntil = 0;
    var muted = true;

    function renderMedia() {
      if (!mainWrap || !thumbs.length) return;
      var t = thumbs[index];
      var type = t.getAttribute("data-media-type");
      if (type === "video") {
        var vsrc = t.getAttribute("data-full-src");
        var poster = t.getAttribute("data-poster") || "";
        mainWrap.innerHTML =
          '<video src="' + vsrc + '" poster="' + poster + '" autoplay ' + (muted ? "muted " : "") +
          'playsinline preload="auto"></video>' +
          '<button type="button" class="mc-gallery__mute" data-mc-mute aria-label="' + (muted ? "Unmute video" : "Mute video") + '">' +
          (muted
            ? '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/><line x1="22" x2="16" y1="9" y2="15"/><line x1="16" x2="22" y1="9" y2="15"/></svg>'
            : '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/><path d="M16 9a5 5 0 0 1 0 6"/><path d="M19.364 18.364a9 9 0 0 0 0-12.728"/></svg>') +
          '</button>';
        var video = mainWrap.querySelector("video");
        if (video) {
          video.playbackRate = 0.75;
          video.addEventListener("pause", function () { autoplay = false; });
          video.addEventListener("ended", function () {
            if (autoplay) { index = 0; renderMedia(); scheduleAdvance(); }
          });
        }
        clearTimeout(autoplayTimer);
      } else {
        mainWrap.innerHTML = '<img src="' + t.getAttribute("data-full-src") + '" alt="' + (t.getAttribute("data-alt") || "") + '">';
        scheduleAdvance();
      }
      thumbs.forEach(function (b, bi) { b.classList.toggle("active", bi === index); });
    }
    function scheduleAdvance() {
      clearTimeout(autoplayTimer);
      if (!autoplay || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      autoplayTimer = setTimeout(function () {
        index = (index + 1) % thumbs.length;
        renderMedia();
      }, 4000);
    }
    function show(i, userAction) {
      index = (i + thumbs.length) % thumbs.length;
      if (userAction) { autoplay = false; clearTimeout(autoplayTimer); }
      renderMedia();
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { show(i, true); }); });
    root.querySelectorAll("[data-mc-prev]").forEach(function (b) { b.addEventListener("click", function () { show(index - 1, true); }); });
    root.querySelectorAll("[data-mc-next]").forEach(function (b) { b.addEventListener("click", function () { show(index + 1, true); }); });
    root.querySelectorAll("[data-mc-thumbs-scroll]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!thumbStrip) return;
        thumbStrip.scrollBy({ left: parseInt(b.getAttribute("data-mc-thumbs-scroll"), 10) * thumbStrip.clientWidth * 0.8, behavior: "smooth" });
      });
    });
    root.addEventListener("click", function (e) {
      var m = e.target.closest("[data-mc-mute]");
      if (m) { muted = !muted; renderMedia(); }
    });

    /* Resume autoplay when gallery scrolls out of view (respecting swatch lock) */
    var galleryEl = root.querySelector("[data-mc-gallery]");
    if (galleryEl && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting && !autoplay && Date.now() >= autoplayLockUntil) {
          autoplay = true;
          scheduleAdvance();
        }
      }, { threshold: 0 }).observe(galleryEl);
    }

    /* ----- Colour swatches ----- */
    var swatches = Array.prototype.slice.call(root.querySelectorAll("[data-mc-swatch]"));
    var nameEl = root.querySelector("[data-mc-colour-name]");
    var descEl = root.querySelector("[data-mc-colour-desc]");
    var priceEl = root.querySelector("[data-mc-price]");
    var addBtn = root.querySelector("[data-mc-add]");
    var qtyEl = root.querySelector("[data-mc-qty]");
    var qty = 1;

    function selectSwatch(btn, scroll) {
      swatches.forEach(function (s) { s.classList.remove("active"); });
      btn.classList.add("active");
      if (nameEl) nameEl.textContent = btn.getAttribute("data-colour");
      if (descEl) descEl.textContent = btn.getAttribute("data-description") || "";
      var vPrice = btn.getAttribute("data-variant-price");
      if (priceEl && vPrice) priceEl.textContent = vPrice;
      if (addBtn) {
        addBtn.setAttribute("data-variant-id", btn.getAttribute("data-variant-id") || "");
        addBtn.disabled = btn.getAttribute("data-variant-available") === "false" || !btn.getAttribute("data-variant-id");
      }
      var mediaIdx = btn.getAttribute("data-media-index");
      if (mediaIdx !== null && mediaIdx !== "") {
        autoplay = false;
        clearTimeout(autoplayTimer);
        autoplayLockUntil = Date.now() + 60000;
        setTimeout(function () { autoplay = true; scheduleAdvance(); }, 60000);
        show(parseInt(mediaIdx, 10), false);
        autoplay = false;
      }
      if (scroll) window.scrollTo({ top: 0, behavior: "smooth" });
    }
    swatches.forEach(function (btn) {
      btn.addEventListener("click", function () { selectSwatch(btn, true); });
    });

    /* Colour from ?color= URL param */
    try {
      var urlColour = new URLSearchParams(window.location.search).get("color");
      if (urlColour) {
        var match = swatches.find ? swatches.find(function (s) { return (s.getAttribute("data-colour") || "").toLowerCase() === urlColour.toLowerCase(); }) : null;
        if (match) {
          selectSwatch(match, false);
          setTimeout(function () {
            if (galleryEl) galleryEl.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100);
        }
      }
    } catch (e) { /* ignore */ }

    /* ----- Qty + add to cart ----- */
    root.querySelectorAll("[data-mc-qty-change]").forEach(function (b) {
      b.addEventListener("click", function () {
        qty = Math.max(1, qty + parseInt(b.getAttribute("data-mc-qty-change"), 10));
        if (qtyEl) qtyEl.textContent = qty;
      });
    });
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var variantId = addBtn.getAttribute("data-variant-id");
        if (!variantId) return;
        addBtn.disabled = true;
        var original = addBtn.innerHTML;
        addBtn.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
        Cart.add(variantId, qty).then(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = original;
          Cart.sync();
          toast("Added to basket");
        }).catch(function (err) {
          addBtn.disabled = false;
          addBtn.innerHTML = original;
          toast(err.message || "Could not add to basket");
        });
      });
    }

    /* ----- Buy Now buttons: scroll to colour picker + toast ----- */
    root.querySelectorAll("[data-mc-buy-now]").forEach(function (b) {
      b.addEventListener("click", function () {
        var target = document.getElementById("choose-colour");
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo({ top: 0, behavior: "smooth" });
        toast("Choose your colour, set your quantity, then add to basket to checkout.");
      });
    });

    /* ----- Transformations slideshow (10s autoplay) ----- */
    var tImgs = Array.prototype.slice.call(root.querySelectorAll("[data-mc-transform-img]"));
    var tDots = Array.prototype.slice.call(root.querySelectorAll("[data-mc-transform-dot]"));
    if (tImgs.length > 1) {
      var tIndex = 0;
      var tTimer = null;
      function tShow(i) {
        tIndex = (i + tImgs.length) % tImgs.length;
        tImgs.forEach(function (img, ii) { img.classList.toggle("active", ii === tIndex); });
        tDots.forEach(function (d, di) { d.classList.toggle("active", di === tIndex); });
      }
      function tStart() {
        if (tTimer) clearInterval(tTimer);
        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          tTimer = setInterval(function () { tShow(tIndex + 1); }, 10000);
        }
      }
      root.querySelectorAll("[data-mc-transform-prev]").forEach(function (b) { b.addEventListener("click", function () { tShow(tIndex - 1); tStart(); }); });
      root.querySelectorAll("[data-mc-transform-next]").forEach(function (b) { b.addEventListener("click", function () { tShow(tIndex + 1); tStart(); }); });
      tDots.forEach(function (d, di) { d.addEventListener("click", function () { tShow(di); tStart(); }); });
      tShow(0);
      tStart();
    }

    renderMedia();
  }

  /* ---------- Transformations lightbox ---------- */
  function initXformLightbox() {
    var lightbox = document.querySelector("[data-xform-lightbox]");
    if (!lightbox) return;
    var img = lightbox.querySelector("[data-xform-lightbox-img]");
    function open(src) { if (!src) return; img.src = src; lightbox.classList.add("open"); lightbox.setAttribute("aria-hidden", "false"); }
    function close() { lightbox.classList.remove("open"); lightbox.setAttribute("aria-hidden", "true"); img.src = ""; }
    document.querySelectorAll("[data-xform-zoom]").forEach(function (el) {
      el.addEventListener("click", function () { open(el.getAttribute("data-xform-zoom")); });
    });
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox || e.target.closest("[data-xform-close]")) close();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---------- Transformations: shuffle + incremental "load more" ---------- */
  function initXformMore() {
    document.querySelectorAll(".xform__grid").forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll(".xform__card"));
      var total = cards.length;

      /* Always un-fade, even if there is nothing to do, so a shuffled grid
         can never get stuck invisible. */
      function ready() { grid.classList.add("is-ready"); }
      if (!total) { ready(); return; }

      /* Optional shuffle (homepage collection pull) — Fisher-Yates, then
         re-append in the new order in one go so there is a single reflow. */
      if (grid.getAttribute("data-xform-shuffle") === "true") {
        for (var s = cards.length - 1; s > 0; s--) {
          var r = Math.floor(Math.random() * (s + 1));
          var tmp = cards[s]; cards[s] = cards[r]; cards[r] = tmp;
        }
        var frag = document.createDocumentFragment();
        cards.forEach(function (c) { frag.appendChild(c); });
        grid.appendChild(frag);
      }

      var btn = grid.id ? document.querySelector('[data-xform-more="' + grid.id + '"]') : null;
      var wrap = btn ? btn.parentNode : null;
      var mob = parseInt(grid.getAttribute("data-mob-limit"), 10) || 8;
      var desk = parseInt(grid.getAttribute("data-desk-limit"), 10) || 9;

      /* Batch size = whatever that breakpoint shows initially. */
      function batch() {
        return window.matchMedia("(min-width: 640px)").matches ? desk : mob;
      }

      var visible = batch();

      function apply() {
        for (var i = 0; i < total; i++) {
          cards[i].classList.toggle("is-shown", i < visible);
        }
        /* Hide the button once everything is out, restore it if the
           breakpoint changes and there is more to show again. */
        if (wrap) wrap.style.display = visible >= total ? "none" : "";
      }

      if (btn) {
        btn.addEventListener("click", function () {
          visible += batch();
          if (visible > total) visible = total;
          apply();
        });
      }

      /* If the viewport crosses the breakpoint, make sure at least that
         breakpoint's baseline is showing. */
      window.addEventListener("resize", function () {
        var b = batch();
        if (visible < b) { visible = b; }
        apply();
      });

      apply();
      ready();
    });
  }

  /* ---------- Delivery estimate engine (shared: product + cart) ---------- */
  /* EDIT THESE RULES ANYTIME — nothing else needs changing. */
  var DELIVERY_CONFIG = {
    cutoffHour: 14,          // 2pm local cutoff
    workingDays: [1,2,3,4,5,6], // Mon..Sat working (0=Sun excluded). Remove 6 to exclude Saturday.
    leadWorkingDays: { EUR: 1, GBP: 2, DEFAULT: 2 }, // working days after dispatch: IE=1, UK=2
    // Add bank/public holidays as "YYYY-MM-DD". Keep IE and UK separate.
    holidays: {
      EUR: [ /* e.g. "2026-12-25", "2026-12-26" */ ],
      GBP: [ /* e.g. "2026-12-25", "2026-12-26" */ ]
    }
  };

  function deIsWorkingDay(date, region) {
    var dow = date.getDay();
    if (DELIVERY_CONFIG.workingDays.indexOf(dow) === -1) return false;
    var iso = date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, "0") + "-" +
      String(date.getDate()).padStart(2, "0");
    var hols = DELIVERY_CONFIG.holidays[region] || [];
    if (hols.indexOf(iso) !== -1) return false;
    return true;
  }
  function deAddWorkingDays(date, n, region) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (deIsWorkingDay(d, region)) n--;
    }
    return d;
  }
  function deNextWorkingDay(date, region) {
    var d = new Date(date.getTime());
    while (!deIsWorkingDay(d, region)) d.setDate(d.getDate() + 1);
    return d;
  }
  function deFormat(date) {
    var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return days[date.getDay()] + ", " + date.getDate() + " " + months[date.getMonth()];
  }

  function deCalculate(region) {
    var lead = DELIVERY_CONFIG.leadWorkingDays[region] || DELIVERY_CONFIG.leadWorkingDays.DEFAULT;
    var now = new Date();
    var beforeCutoff = now.getHours() < DELIVERY_CONFIG.cutoffHour;

    // Dispatch day: today if a working day AND before cutoff; else next working day.
    var dispatch;
    if (deIsWorkingDay(now, region) && beforeCutoff) {
      dispatch = new Date(now.getTime());
    } else {
      dispatch = deNextWorkingDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1), region);
    }
    var arrival = deAddWorkingDays(dispatch, lead, region);

    // Minutes remaining until cutoff (only meaningful if before cutoff on a working day today)
    var minsLeft = null;
    if (deIsWorkingDay(now, region) && beforeCutoff) {
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), DELIVERY_CONFIG.cutoffHour, 0, 0);
      minsLeft = Math.max(0, Math.floor((cutoff - now) / 60000));
    }
    return { arrival: arrival, minsLeft: minsLeft, beforeCutoff: (minsLeft !== null) };
  }

  function deRegionFromCurrency(cur) {
    if (cur === "EUR") return "EUR";
    if (cur === "GBP") return "GBP";
    return "DEFAULT";
  }

  function deCountdownText(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (h > 0) return h + "h " + m + "m";
    return m + "m";
  }

  function initDeliveryEstimate() {
    var els = document.querySelectorAll("[data-delivery-estimate]");
    if (!els.length) return;

    function render() {
      els.forEach(function (el) {
        var cur = el.getAttribute("data-currency") || "EUR";
        var region = deRegionFromCurrency(cur);
        var res = deCalculate(region);
        var dateStr = deFormat(res.arrival);
        var textEl = el.querySelector("[data-de-text]");
        var isCart = el.classList.contains("delivery-estimate--cart");
        if (!textEl) return;
        if (isCart) {
          textEl.textContent = dateStr;
        } else if (res.beforeCutoff && res.minsLeft !== null) {
          textEl.innerHTML = "Order within <strong>" + deCountdownText(res.minsLeft) +
            "</strong> for estimated delivery <strong>" + dateStr + "</strong>";
        } else {
          textEl.innerHTML = "Order now for estimated delivery <strong>" + dateStr + "</strong>";
        }
      });
    }
    render();
    // Refresh the countdown once a minute so it stays live.
    setInterval(render, 60000);
  }

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    initProductPage();
    initSlideshows();
    initCalculator();
    initMagicCoat();
    initXformLightbox();
    initXformMore();
    initDeliveryEstimate();
    Cart.sync();
  });
})();
